<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

const store = useStore();
const { t } = useI18n();

const active = computed(() => store.getters['painelView/getStatusFilter']);

const STATUSES = [
  { id: 'pending', classes: 'bg-n-amber-3 text-n-amber-12' },
  { id: 'confirmed', classes: 'bg-n-teal-3 text-n-teal-12' },
  { id: 'cancelled', classes: 'bg-n-slate-3 text-n-slate-11 line-through' },
];

const isActive = id => active.value.has(id);
const toggle = id => store.dispatch('painelView/toggleStatus', id);
</script>

<template>
  <div>
    <div
      class="mb-2.5 text-[11px] font-semibold uppercase tracking-wider text-n-slate-11"
    >
      {{ t('PAINEL.APPOINTMENTS.SIDEBAR.STATUS') }}
    </div>
    <div class="flex flex-wrap gap-1.5">
      <button
        v-for="s in STATUSES"
        :key="s.id"
        class="rounded-full px-2.5 py-1 text-xs font-medium transition-opacity"
        :class="[s.classes, isActive(s.id) ? 'opacity-100' : 'opacity-40']"
        @click="toggle(s.id)"
      >
        {{ t(`PAINEL.APPOINTMENTS.STATUS.${s.id.toUpperCase()}`) }}
      </button>
    </div>
  </div>
</template>
